import {toast} from "react-toastify";

export const validateSliderImageSize = (file) => {
    if (file.size > 500 * 1024) {
        // File size is less than 500 KB
        toast.error('File size should be less than 500 KB');
        return false;
    }
    return true;
}

export const validateSliderImageDimensionAndImageValidity = async (file) => {
    // Check if file is an image
    if (!file.type.startsWith("image/")) {
        toast.error("File is not an image.");
        return false;
    }

    // Create a new FileReader instance
    const reader = new FileReader();

    // Read the uploaded file as a data URL using async/await
    const imageDataUrl = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    // Create a new Image instance
    const image = new Image();

    // Load the image data URL using async/await
    await new Promise((resolve, reject) => {
        image.onload = () => resolve();
        image.onerror = reject;
        image.src = imageDataUrl;
    });

    // console.log("Width:", image.width);
    // console.log("Height:", image.height);

    if (image.width === 1920 && image.height === 570) return true;
    else {
        toast.error("Image Dimension must be 1920 * 570");
        return false;
    }
};
